module.exports = __webpack_public_path__ + "img/labelsDisplay.3c4f84d0.svg";